import { useEffect, useState, useMemo } from 'react';

import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';
import { StepType } from 'src/store/RoofStoreModule';

import { Step } from './StepButton';

import { step1Icon, step2Icon, step3Icon, step4Icon, step5Icon, step6Icon } from 'src/assets/images';

interface StepWithId extends Step {
  id: number;
}

export const usePresenter = () => {
  const { dispatch, roofStore } = useStoreon<IState, IEvents>('roofStore');

  const allSteps: StepWithId[] = useMemo(() => [
    { id: 1, icon: step1Icon, color: 'empty', text: 'Выбор типа кровли' },
    { id: 2, icon: step2Icon, color: 'empty', text: 'Ввод размеров' },
    { id: 3, icon: step3Icon, color: 'empty', text: 'Выбор профиля' },
    { id: 4, icon: step5Icon, color: 'empty', text: 'Выбор покрытия' },
    { id: 5, icon: step4Icon, color: 'empty', text: 'Выбор цвета' },
    { id: 6, icon: step6Icon, color: 'empty', text: 'Резуль­таты расчета' },
  ], [])

  const [steps, setSteps] = useState<StepWithId[]>(allSteps);

  useEffect(() => {
    const newSteps = allSteps.map(step => {
      step.color = step.id <= roofStore.stepID ? 'filled' : 'empty';
      return step;
    });

    setSteps(newSteps);
  }, [allSteps, roofStore.stepID]);

  const changeStep = (stepID: StepType) => dispatch('roof/set-stepID', { stepID });

  return {
    currentStep: roofStore.stepID,
    steps,
    changeStep,
  };
};
